import { useEffect, useState } from 'react';
import DropDownMenu from '../../../../shared/ui/dropdown-menu/DropDownMenu';
import s from './CreatePostBlock.module.css';
import { useSelector } from 'react-redux';
import { Tooltip as ReactTooltip } from 'react-tooltip';
import {
    selectCurrentProject,
    selectInputPrompt,
} from '../../../../store/selectors/projectSelectors';
import { setInputPrompt, setSelectedSocialMedia } from '../../../../store/slices/projectSlice';
import Button from '../../../../shared/ui/button/Button';
import { getSuggestions } from '../../../../store/slices/onboardingSlice';
import { useAppDispatch } from '../../../../store/store';
import { setGenerationMode } from '../../../../store/slices/projectSlice';
import { selectGenerationMode } from '../../../../store/selectors/projectSelectors';
import { selectSuggestions } from '../../../../store/selectors/onboardingSelector';
import { socialMediaOptions } from '../../../../shared/constant/constant';
import { generateContent, updateProject } from '../../../../shared/api/textProjectApi';
import { selectIsBasicSubscription } from '../../../../store/selectors/subscriptionSelector';
import { setPricingModal } from '../../../../store/slices/pageSlice';
import IconLock from '../../../../shared/ui/icons/IconLock';
import { toast } from 'react-toastify';
const CreatePostBlock = () => {
    const dispatch = useAppDispatch();
    const currentProject = useSelector(selectCurrentProject);
    const suggestions = useSelector(selectSuggestions);
    const generationMode = useSelector(selectGenerationMode);

    const prompt = useSelector(selectInputPrompt);

    const [selectedSuggestion, setSelectedSuggestion] = useState<string | null>(null);
    const [newSocialMedia, setNewSocialMedia] = useState(currentProject?.content_type || '');
    const [isLoadingSuggestions, setIsLoadingSuggestions] = useState(false);

    const isBasicSubscription = useSelector(selectIsBasicSubscription);

    const handlePromptSuggestions = async () => {
        if (isBasicSubscription) {
            dispatch(setPricingModal(true));
            return;
        }
        try {
            setIsLoadingSuggestions(true);
            await dispatch(getSuggestions(prompt));
        } catch (error) {
            console.log(error);
        } finally {
            setIsLoadingSuggestions(false);
        }
    };

    const handleGenerationMode = (mode: 'text_image' | 'text_only' | 'image_only' | null) => {
        dispatch(setGenerationMode(mode));
    };

    const handleSelectNewSocialMedia = async (socialMedia: string) => {
        setNewSocialMedia(socialMedia);
        dispatch(setSelectedSocialMedia(socialMedia));
        await dispatch(updateProject({ ...currentProject, content_type: socialMedia }));

        const projectPrompt = currentProject?.prompt || '';
        if (projectPrompt != '') {
            await handleGenerateScript();
        }
    };

    const handleGenerateScript = async () => {
        if (currentProject?.id) {
            try {
                const response = await dispatch(
                    generateContent({ projectId: currentProject.id, kind: 'text_only' }),
                ).unwrap();
                console.log('Script generated successfully:', response);
            } catch (error: any) {
                toast.error(error?.message || 'Failed to handle generate script');
                console.error('Failed to handle generate script:', error);
            }
        }
    };

    const handleSelectSuggestion = (suggestion: string) => {
        setSelectedSuggestion(suggestion);
        dispatch(setInputPrompt(suggestion));
    };

    console.log(generationMode, 'generationMode');
    console.log(newSocialMedia, 'newSocialMedia');
    return (
        <div className={s.container}>
            <DropDownMenu
                options={socialMediaOptions}
                selectedOption={newSocialMedia}
                setSelectedOption={handleSelectNewSocialMedia}
            />
            <h3 className={s.title}>Generation mode</h3>
            <div className={s.generation_mode_container}>
                <label className={s.radio_option}>
                    <input
                        type="radio"
                        name="generation_mode"
                        value="text_only"
                        checked={generationMode === 'text_only'}
                        onChange={() => handleGenerationMode('text_only')}
                    />
                    <span className={s.radio_label}>Text only</span>
                </label>

                <label className={s.radio_option}>
                    <input
                        type="radio"
                        name="generation_mode"
                        value="image_only"
                        checked={generationMode === 'image_only'}
                        onChange={() => handleGenerationMode('image_only')}
                    />
                    <span className={s.radio_label}>Image only</span>
                </label>

                <label className={s.radio_option}>
                    <input
                        type="radio"
                        name="generation_mode"
                        value="text_image"
                        checked={generationMode === 'text_image'}
                        onChange={() => handleGenerationMode('text_image')}
                    />
                    <span className={s.radio_label}>Text image</span>
                </label>
            </div>

            <h3 className={s.title}>Need more ideas?</h3>
            <p className={s.subtitle}>Discover our hand-picked prompts</p>
            <Button
                text={isLoadingSuggestions ? 'Searching prompts...' : 'Prompt suggestions'}
                onClick={handlePromptSuggestions}
                icon={isBasicSubscription ? <IconLock color="white" /> : undefined}
                state={isLoadingSuggestions ? 'loading' : 'enabled'}
                style={{
                    width: '100%',
                    background: 'linear-gradient(90deg, #8801FF 0%, #D400FF 100%)',
                    color: 'white',
                    marginTop: '10px',
                }}
            />
            <div className={s.suggestionWrapper}>
                {suggestions &&
                    suggestions.length > 0 &&
                    suggestions.map((suggestion, index) => (
                        <div key={index}>
                            <p
                                className={`${s.suggestion} ${selectedSuggestion === suggestion ? s.active : ''}`}
                                onClick={() => handleSelectSuggestion(suggestion)}
                                data-tooltip-id={`suggestion-${index}`}
                            >
                                {suggestion}
                            </p>
                            <ReactTooltip
                                id={`suggestion-${index}`}
                                place="top"
                                content={suggestion}
                                className={s.tooltip}
                            />
                        </div>
                    ))}
                {!isLoadingSuggestions && suggestions && suggestions.length === 0 && (
                    <p className={s.no_suggestions}>
                        No suggestions available. Try clicking retry.
                    </p>
                )}
            </div>
        </div>
    );
};

export default CreatePostBlock;
